'use client';

import { CategoryForm } from '@/components/admin/services/CategoryForm';

export default function AdminServiceCategoryNewPage() {
  return <CategoryForm />;
}
